import { cn } from '@helpers/cn';
import { PopoverFloating as Popover } from '@components/core-ui/PopoverFloating';
import { NotificationsPopover } from '@components/Header/components/NotificationsIcon/components/NotificationsPopover';
import NotificationsEmptyIcon from '@components/icons/NotificationsEmpty.svg';
import NotificationsUnseenIcon from '@components/icons/NotificationsUnseen.svg';
import { useAuthContext } from '@providers/AuthProvider';
import { useRef, useState } from 'react';

export const NotificationsIcon = () => {
  const { me, lastNotifications } = useAuthContext();
  const wrapperRef = useRef<HTMLButtonElement>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  if (!me) {
    return null;
  }

  const notifications = lastNotifications || [];
  const isUnseen = notifications.some((n) => !n.seen);
  const isOpen = anchorEl !== null;

  const toggleOpen = () => setAnchorEl((current) => (current ? null : wrapperRef.current));

  const iconClassName = cn(
    'notificationIcon rounded-[5px] text-[var(--color-text-muted)] hover:text-[var(--color-on-surface)] group-hover:bg-[var(--color-tint)]',
    isOpen ? 'text-[var(--color-on-surface)] bg-[var(--color-tint)]' : '',
  );

  return (
    <>
      <div className="flex justify-center items-center rounded-[5px]">
        <button
          type="button"
          ref={wrapperRef}
          aria-label="Notifications"
          aria-expanded={isOpen}
          onClick={toggleOpen}
          className="min-h-11 min-w-11 flex items-center justify-center cursor-pointer relative rounded-[5px] group"
        >
          {!isUnseen ? (
            <NotificationsEmptyIcon className={iconClassName} />
          ) : (
            <NotificationsUnseenIcon className={iconClassName} />
          )}
        </button>
      </div>

      <Popover
        open={isOpen}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorEl={anchorEl}
        className="rounded-lg max-w-[calc(100vw-2rem)]"
      >
        <NotificationsPopover />
      </Popover>
    </>
  );
};
